import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ImagePropType, ObjectPropsPropType } from '../../../../../../services/proptypes';
import TeamMember from '../../TeamMember';
var defaultProps = {
  photo: null,
  role: '',
  buttonText: 'Book',
  buttonProps: {}
};
export default function InstagramTeamMember(_ref) {
  var name = _ref.name,
    url = _ref.url,
    photo = _ref.photo,
    role = _ref.role,
    onClick = _ref.onClick,
    buttonText = _ref.buttonText,
    buttonProps = _ref.buttonProps;
  return /*#__PURE__*/React.createElement(TeamMember, {
    className: "instagram-team-member"
  }, /*#__PURE__*/React.createElement(TeamMember.Photo, {
    src: photo
  }), /*#__PURE__*/React.createElement(TeamMember.Content, null, /*#__PURE__*/React.createElement(TeamMember.Name, {
    name: name
  }), /*#__PURE__*/React.createElement(TeamMember.Instagram, {
    url: url
  }), /*#__PURE__*/React.createElement(TeamMember.Role, {
    role: role
  }), /*#__PURE__*/React.createElement(TeamMember.Button, _extends({
    onClick: onClick,
    text: buttonText
  }, buttonProps))));
}
InstagramTeamMember.defaultProps = defaultProps;